import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  requestingTitle: {
    description: 'bulkVoid.requestingTitle',
    defaultMessage: 'Requesting',
    id: 'x59lkC',
  },
  requestingContent: {
    description: 'bulkVoid.requestingContent',
    defaultMessage: 'Sending the Request to void Shipments',
    id: 'HClIAU',
  },
});
